import { gql } from '@apollo/client';

const INITIALIZE_IMAGE_MAP_DOWNLOAD = gql`
  mutation InitializeImageMapDownload($shareId: Int) {
    initImageMapDownload(shareId: $shareId)
  }
`;

export default INITIALIZE_IMAGE_MAP_DOWNLOAD;
